<template>
  <transition name="menu">
    <div v-show="show" class="slide-menu">
      <h1 v-text="$t('view.contents')"></h1>
      <div>
        <div v-for="(menuGorup, key) in _.groupBy(menus, 'type')" :key="key" class="slide-menu-group">
          <div v-if="key == 'process'" class="slide-menu-title" style="padding-top: 4px; padding-bottom: 4px;">{{ $t('view.processTitle') }}</div>
          <div v-for="(menu, index) in menuGorup" :key="index">
            <div class="slide-menu-item" :class="{'selected': menu === activeMenu}" @click="hanldeMenuClick(menu)">
              <span class="H1">
                <i :class="menu._active ? 'el-icon-caret-bottom' : 'el-icon-caret-right'" :style="menu._collapse ? '' : 'opacity: 0;'"/>
                {{ menu.hotspot.title }}
              </span>
            </div>
            <el-collapse-transition v-if="menu._collapse">
              <ul v-show="menu._active">
                <template v-for="(children, key) in menu.children">
                  <li v-if="_.isString(key)&&$i18n.locale != 'zh'" :key="key" class="slide-menu-title">
                    {{ _.get(_.get(evaluations, key), 'label') }}
                  </li>
                  <li v-for="child in children" :key="child.uid" class="slide-menu-item" :class="{'focus': child._focus}" @click="hanldeMenuChildClick(child)">
                    {{ child.title }}
                  </li>
                </template>
              </ul>
            </el-collapse-transition>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'NavMenu',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    evaluations: Object,
    menus: Array
  },
  inject: ['hideAllHotspots', 'showAllHotspots'],
  watch: {
    menus(menus) {
      if (!this.activeMenu && !this._.isEmpty(menus)) {
        this.selectFirstAuditMenu()
      }
    },
    activeMenu: {
      handler(menu, oldMenu) {
        if (oldMenu) {
          oldMenu._active = false
        }
        if (menu) {
          menu._active = true
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      activeMenu: null,
    }
  },
  methods: {
    // 选择第一个审核菜单栏
    selectFirstAuditMenu() {
      this.hanldeMenuClick(this._.find(this.menus, {type: 'audit'}))
    },

    hanldeMenuClick(menu, noEmit) {
      if (this.activeMenu === menu) {
        menu._active = !menu._active
      } else {
        if (!noEmit) {
          this.$emit('change', { name: 'hotspot', hotspot: menu.hotspot })
        }
        this.activeMenu = menu
        if (menu.type === 'audit') {
          this.showAllHotspots()
        } else {
          this.hideAllHotspots()
        }
      }
    },
    hanldeMenuChildClick(child) {
      this.$emit('change', { name: 'hotspot', hotspot: child })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.menu-enter-active, .menu-leave-active {
  transition: all .2s;
}
.menu-enter, .menu-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}
.slide-menu {
  position: fixed;
  width: 260px;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 1010;
  & > h1 {
    padding: 16px 20px;
    // margin-bottom: 12px;
    color: #FFF;
    font-size: 18px;
    border-bottom: 1px solid $border-color-lighter;
  }

  @include bg-blur;

  & > div {
    width: 100%;
    height: 100%;
    max-height: calc(100% - 72px);
    overflow: auto;
    @include scrollbar;
  }

  ul {
    li {
      padding-left: 38px !important;
      color: #D8D7D6 !important;
    }
  }

  &::after {
    content: "";
    display: none;
    position: absolute;
    bottom: -25px;
    left: 99px;
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-top: 15px solid rgba($color-black,.57);
  }

  .slide-menu-title {
    color: rgba(216,215,214,.5) !important;
    padding: 8px 18px;
    font-size: 12px;
    // border-bottom: 1px solid $color-warning;
  }

  .slide-menu-group {
    padding: 12px 0;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      display: block;
      border-bottom: 1px solid rgba(216,215,214,.5);
      left: 18px; right: 18px;
      bottom: 0;
    }
  }

  .slide-menu-item {
    background-color: transparent;
    color: #FFFFFF;
    border-width: 0;
    font-size: 14px;
    padding: 8px 18px;
    transition: .3s;
    // margin: 2px 10px;
    // border-radius: 10px;
    cursor: pointer;

    & i {
      margin-right: 5px;
    }

    &:hover {
      color: $color-warning !important;
    }

    &.selected {
      color: #E9CB91;
    }

    &.focus {
      color: $color-warning !important;
      background-color: rgba($color-black, .28);
    }
  }

  .H1 {
    font-weight: bold;
  }

  &.active {
    width: 275px;
    opacity: 1;

    &::after {
      display: block;
    }
  }

  &.hide {
    opacity: 0;
  }

  &:hover {
    opacity: 1 !important;
  }
}
</style>